import request from "@/utils/request";

// 扫码入库
export const getCaptcha = (params) => {
  return request({
    url: "common/captcha",
    method: "get",
    responseType: "arraybuffer",
    withCredentials: true,
    params,
  });
};

// 获取专利类型
export const getType = (params) => {
  return request({
    url: "index/zllx",
    method: "get",
    params,
  });
};

// 获取专利类型
export const getDomain = (params) => {
  return request({
    url: "index/cyly",
    method: "get",
    params,
  });
};

// 专利查询
export const patentSearch = (params) => {
  return request({
    url: "index/search",
    withCredentials: true,
    method: "post",
    params,
  });
};

// 获取底部信息
export const getInfo = (params) => {
  return request({
    url: "index/xinx",
    method: "get",
    params,
  });
};

// 提交技术需求

export const jsxqApi = (params) => {
  return request({
    url: "index/jsxq",
    method: "post",
    params,
  });
};